import React from 'react';
import styled from 'styled-components';
const LoadingEllipseContainer = styled.div `
  display: inline-block;
  position: relative;
  width: 10px;
  height: 10px;

  &>div {
    position: absolute;
    top: 2px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${(props) => props.theme.button.background};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  &>div:nth-child(1) {
    left: 4px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  &>div:nth-child(2) {
    left: 4px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  &>div:nth-child(3) {
    left: 16px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  &>div:nth-child(4) {
    left: 28px;
    animation: lds-ellipsis3 0.6s infinite;
  }

  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(12px, 0);
    }
  }
`;
export default function CssLoadingEllipses(ariaLabel) {
    return (React.createElement(LoadingEllipseContainer, { "aria-label": ariaLabel || "Loading animation", role: "img" },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)));
}
